<script lang="ts">
	import type { StoryblokAsset } from '#library/components.schema.build.ts'
	import Image from './image.svelte'
	import { linky } from '#library/linky.ts'

	interface Props {
		link: string
		image?: Partial<StoryblokAsset>
		suptitle?: string
		title: string
		subtitle: string
		caption: string
		theme?: string
		body?: string
	}

	let { link, image, suptitle, title, subtitle, caption, theme, body }: Props = $props()

	const href = $derived(linky`${link}`)
</script>

<a class="card {theme || 'theme-rose-on-white'}" {href}>
	<figure class="figure">
		{#if image?.filename}
			<Image src={image.filename} alt={caption} focus={image.focus} aspect="16/8" />
		{/if}
		<!-- <figcaption class="caption">{caption}</figcaption> -->
	</figure>
	<div class="content">
		<div class="suptitle">{suptitle}</div>
		<div class="title">{title}</div>
		<div class="body">{body}</div>
		<div class="subtitle">{subtitle}</div>
	</div>
</a>

<style lang="css">
	.card {
		color: var(--c-charcoal);
		display: grid;
		gap: 1rem;

		@media (--from-mobile) {
			gap: 2rem;
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}
	}

	.caption {
		background-color: var(--c-background);
		color: var(--c-foreground);
		font: 500 var(--f-signpost);
		letter-spacing: var(--ls-signpost);
		padding: 0.375rem 1rem;
		text-align: center;
		text-transform: uppercase;
	}

	.content {
		@media (--from-mobile) {
			grid-column: span 2;
		}
	}

	.suptitle {
		font: 400 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-start: 1.75rem;
		text-transform: uppercase;
	}

	.title {
		font: 600 var(--f-h6);
		letter-spacing: var(--ls-h6);

		@media (--from-mobile) {
			margin-block-start: 0.625rem;
		}
	}

	.subtitle {
		font: 400 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-start: 0.75rem;
	}
</style>
